import React from 'react';

const getCurrentUrl = (authList: any[], currentPath: string) => {
    return authList?.find(entry => entry?.url === currentPath)?.name;
};
export default getCurrentUrl;
